var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './CopyText.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CopyOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { useCallback, useEffect, useRef } from 'react';
import { useBoolean, useClipboard, usePrevious } from '@hooks';
export const selectElementText = (element) => {
    if (window.getSelection && element) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
        selection === null || selection === void 0 ? void 0 : selection.addRange(range);
    }
};
export const CopyText = (props) => {
    const { buttonOnly, displayText, className, onClick, text, tooltip } = props, rest = __rest(props, ["buttonOnly", "displayText", "className", "onClick", "text", "tooltip"]);
    const buttonRef = useRef(null);
    const previousText = usePrevious(text);
    const [copied, setCopied] = useBoolean(false);
    const [timedOut, setTimedOut] = useBoolean(false);
    const clipboard = useClipboard();
    const loading = copied && !text;
    const failed = timedOut && !text;
    const highlight = !buttonOnly && !displayText;
    const hoverText = tooltip || COPY_SPECIFIC.CLICK_TO_COPY;
    const copyText = loading ? COPY_SPECIFIC.COPYING : `${COPY_SPECIFIC.COPIED}!`;
    const clickText = failed ? COPY_SPECIFIC.COPY_FAILED : copyText;
    const tooltipText = copied ? clickText : hoverText;
    const buttonText = displayText || text;
    useEffect(() => {
        if (text && text !== previousText) {
            clipboard.writeText(text);
        }
    }, [clipboard, previousText, text]);
    const handleOnClick = useCallback((e) => {
        e.stopPropagation();
        if (onClick) {
            onClick();
        }
        if (text) {
            clipboard.writeText(text);
        }
        setCopied.on();
        setTimedOut.off();
        selectElementText(buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current);
        setTimeout(setTimedOut.on, 3000);
    }, [onClick, text, setCopied, setTimedOut, clipboard]);
    const handleOnMouseLeave = useCallback(() => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        setTimeout(setCopied.off, 500);
    }, [setCopied.off]);
    const copyTextClassNames = classNames('copy-text', className, {
        copied,
        failed,
        highlight
    });
    return (React.createElement(Tooltip, { className: copyTextClassNames, placement: 'bottom', title: tooltipText },
        React.createElement(Button, Object.assign({ icon: React.createElement(CopyOutlined, null), loading: loading, onClick: handleOnClick, onMouseLeave: handleOnMouseLeave, ref: buttonRef }, rest), buttonOnly ? null : buttonText)));
};
